export const passwordReset = {
  // Verifying state
  'passwordReset.verifying': 'Verifying reset link...',

  // Invalid link state
  'passwordReset.invalidTitle': 'Invalid Reset Link',
  'passwordReset.invalidDescription': 'This password reset link is invalid or has expired.',
  'passwordReset.requestNew': 'Please request a new password reset from the login page.',
  'passwordReset.backToLogin': 'Back to Login',

  // Valid link - Set password state
  'passwordReset.setNewTitle': 'Set New Password',
  'passwordReset.setNewDescription': 'Choose a new password for your account',
  'passwordReset.verified': 'Reset Link Verified',
  'passwordReset.enterNew': 'Enter your new password below',

  // Form labels
  'passwordReset.newPassword': 'New Password',
  'passwordReset.newPasswordPlaceholder': 'Enter your new password',
  'passwordReset.confirmPassword': 'Confirm New Password',
  'passwordReset.confirmPasswordPlaceholder': 'Confirm your new password',

  // Password requirements
  'passwordReset.requirementsTitle': 'Password Requirements:',
  'passwordReset.requirement1': 'At least 6 characters long',
  'passwordReset.requirement2': 'Use a mix of letters, numbers, and symbols',
  'passwordReset.requirement3': 'Avoid common passwords',

  // Buttons
  'passwordReset.updating': 'Updating...',
  'passwordReset.updateButton': 'Update Password',
  'passwordReset.cancel': 'Cancel',

  // Toast messages
  'passwordReset.mismatch': 'Passwords do not match',
  'passwordReset.mismatchDescription': 'Please make sure both password fields are identical.',
  'passwordReset.tooShort': 'Password too short',
  'passwordReset.tooShortDescription': 'Password must be at least 6 characters long.',
  'passwordReset.success': 'Password updated successfully',
  'passwordReset.successDescription': 'Your password has been changed. You can now log in with your new password.',
  'passwordReset.failed': 'Password Reset Failed',
  'passwordReset.failedWeak': 'Password is too weak. Please choose a stronger password.',
  'passwordReset.failedExpired': 'Your reset link has expired. Please request a new password reset.',
  'passwordReset.failedGeneric': 'Failed to update password. Please try again.',
} as const;
